import { useContext } from 'react';
import { TemplatesContext, UserContext } from '../store';

export function useIsLoading() {
	const { state: userState } = useContext(UserContext);
	const { state: templateState } = useContext(TemplatesContext);

	return userState.loading || templateState.loading;
}
